import { useEffect, useState } from "react";
import { getWithRetry } from "../lib/fetchWithRetry";
import { overdueMatches } from "../lib/plannedMatches";
import PlannedMatchOverdueCard from "./PlannedMatchOverdueCard";

/**
 * Issue #1150 (D225 item 6) — the PlanMatchAfter card on Record Match. One
 * component for every state of the record (the season record, one match in,
 * and the empty record), so a new player's first planned match is prompted
 * too. Reads the player's planned matches itself (`GET /matches?status=planned`:
 * `GET /matches` lists played ones only, #1148) and renders the overdue ones,
 * oldest first, as `record-match-overdue-<id>`. A failed read leaves no card:
 * the card is a prompt, and its absence claims nothing about the record.
 *
 * New-look only: mounted by the three record screens, none of which the old
 * look reaches (D217).
 */
export default function RecordOverdueCards() {
  const [planned, setPlanned] = useState([]);
  useEffect(() => {
    let cancelled = false;
    getWithRetry("/matches?status=planned")
      .then((r) => { if (!cancelled) setPlanned(Array.isArray(r?.data) ? r.data : []); })
      .catch((e) => console.error("RecordOverdueCards: failed to load planned matches", e));
    return () => { cancelled = true; };
  }, []);
  return overdueMatches(planned).map((m) => (
    <PlannedMatchOverdueCard key={m.match_id} match={m} testId={`record-match-overdue-${m.match_id}`} from="/dashboard" />
  ));
}
